import variables from '../../styles/variables.module.scss';
import caseimg from '../../assets/cases/polar-caseimg.jpg';

export default {
  path: '/cases/polar',
  color: variables.polar,
  case: { fall: caseimg },
  title: 'Polar',
  headline: 'iOS & Android application',
  description: 'Free international transactions in real-time',
  isWeb: false,
  isAndroid: false,
};
